import * as React from "react";
import { Button, Theme, WithStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core/";
import Loading from "../../shared/components/loading/Loading";
import { IPagedCommunityMgmtMemberships } from "../types/IPagedCommunityMgmtMemberships";
import ICommunityOwnership from "../types/ICommunityOwnership";
import ICommunityMembership from "../types/ICommunityMembership";
import DateHelper from "../../shared/helpers/DateHelper";
import { Link } from "react-router-dom";
import { MembershipStatus } from "../types/MembershipStatus";

const styles = (theme: Theme) => ({
  loadMoreButton: {
    marginTop: theme.spacing.unit * 3,
    width: '100%'
  }
});

interface IState {

}

interface IProps extends WithStyles<typeof styles> {
  communityOwnerships: ICommunityOwnership[],
  communityMemberships: IPagedCommunityMgmtMemberships,
  isLoading: boolean,
  loadMoreIsLoading: boolean,
  canLoadMore: boolean,
  onLoadMore(): void,
  isCommunityAdmin(): boolean
}

class CommunityMembershipsOverviewTable extends React.Component<IProps, IState> {
  public render() {
    const { communityMemberships, classes } = this.props;
    
    return (
      <>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Community</TableCell>
              <TableCell>Entity</TableCell>
              <TableCell>NxtEntityId</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Requested On</TableCell>
              <TableCell/>
            </TableRow>
          </TableHead>
          <TableBody>

            {this.props.isLoading && <TableRow>
              <TableCell><Loading/></TableCell>
            </TableRow>}

            {!this.props.isLoading && (
              <>
                {!this.props.isCommunityAdmin() &&
                  <TableRow>
                    <TableCell colSpan={5}>You are not an admin of any community.</TableCell>
                  </TableRow>}

                {this.props.isCommunityAdmin() && communityMemberships.items.length === 0 &&
                  <TableRow>
                    <TableCell colSpan={5}>No community memberships could be found for given filter
                      criteria.</TableCell>
                  </TableRow>}

                {communityMemberships.items.map((membership: ICommunityMembership) =>
                  (
                    <TableRow key={`${membership.communityCode}-${membership.entity.nxtEntityId}`}>
                      <TableCell>{membership.communityName}</TableCell>
                      <TableCell>{membership.entity.name}</TableCell>
                      <TableCell>{membership.entity.nxtEntityId}</TableCell>
                      <TableCell>{membership.status}</TableCell>
                      <TableCell>{DateHelper.FormatDate(membership.createdOn)}</TableCell>
                      <TableCell>
                        <Button color="secondary">
                          <Link to={`memberships/${membership.entity.nxtEntityId}`}>
                            {membership.status === MembershipStatus.PENDING ? 'Verify' : 'Details'}
                          </Link>
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
              </>
            )}
          </TableBody>
        </Table>

        <Button
          variant="contained"
          color="primary"
          onClick={this.props.onLoadMore}
          disabled={this.props.loadMoreIsLoading || !this.props.canLoadMore}
          className={classes.loadMoreButton}
        >
          {this.props.loadMoreIsLoading ? 'LOADING...' : 'LOAD  MORE'}
        </Button>
      </>
    )
  }
}

export default withStyles(styles)(CommunityMembershipsOverviewTable)


// WEBPACK FOOTER //
// ./src/modules/communities/components/CommunityMembershipsOverviewTable.tsx